module.exports = __webpack_public_path__ + "media/images/ipad-3d9ef9c43f2be9b5896033b434988eba.jpeg";